import { defineMessages } from 'react-intl';

export default defineMessages({
  appStoreTitle: {
    id: 'view.loginPage.appStoreTitle',
    defaultMessage: 'IOS mobile app',
  },
});
